import React from 'react';
import { navbarFrame, noFrame, phoneFrame } from './WebFrame.module.scss';

const WebFrame = ({ aspectRatio, webFrame, wrapperClass, children }) => {
  const getFrame = () => {
    if (!webFrame) return noFrame;
    if (aspectRatio < 1) return phoneFrame;
    else return navbarFrame;
  };

  return (
    <div
      className={`shadowBig
    ${wrapperClass ? wrapperClass : ''} ${getFrame()}`}
    >
      {children}
    </div>
  );
};
export default WebFrame;
